const userKey = "_nq_site_user_";

export default userKey;